var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMna0Yq0FRbvml9L(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1144,
    height: 643,
    viewBox: "0 0 1144 643",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H1136C1140.14 0.5 1143.5 3.85786 1143.5 8V635C1143.5 639.142 1140.14 642.5 1136 642.5H8C3.85787 642.5 0.5 639.142 0.5 635V8L0.509766 7.61426C0.710541 3.65139 3.98724 0.5 8 0.5Z",
    fill: "white",
    stroke: "#D6DEE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMna0Yq0FRbvml9L);
export default __webpack_public_path__ + "static/media/mna0yq0f-rbvml9l.eae31ad1ae0abcf7257e79b28b18e5f1.svg";
export { ForwardRef as ReactComponent };